import { WorkflowGraphNode, WorkflowGraph } from 'cio/utils/visual-workflow-builder/workflow-graph';

export function copyUnitNodeCoordinatesToOriginalNodes(workflowGraph: WorkflowGraph, unitNodeGraph: WorkflowGraph) {
  let unitNodesMap = Object.values(unitNodeGraph.nodes).reduce(
    (acc, node) => {
      if (node.type !== 'virtual_unit') {
        return acc;
      }

      if (!node.originalNode) {
        return acc;
      }

      if (!acc[node.originalNode.id]) {
        acc[node.originalNode.id] = [];
      }

      acc[node.originalNode.id].push(node);

      return acc;
    },
    {} as Record<string, WorkflowGraphNode[]>,
  );

  Object.keys(workflowGraph.nodes).forEach((nodeId) => {
    let unitNodes = [...(unitNodesMap[nodeId] ?? [])];
    let xCoords = unitNodes.mapBy('x');
    let yCoords = unitNodes.mapBy('y');

    let meanX = (Math.max(...xCoords) + Math.min(...xCoords)) / 2;
    let meanY = (Math.max(...yCoords) + Math.min(...yCoords)) / 2;

    let nodeInfo = workflowGraph.nodes[nodeId];
    nodeInfo.x = Math.floor(meanX);
    nodeInfo.y = Math.floor(meanY);

    if (nodeInfo.typeCategory === 'action' && nodeInfo.action.isBranch) {
      nodeInfo.branch = workflowGraph.campaign.branchesMap[nodeId];
    }
  });
}

export function normalizeCoordinates(workflowGraph: WorkflowGraph, padding: { x: number; y: number } = { x: 0, y: 0 }) {
  let minX = Math.floor(Math.min(...Object.values(workflowGraph.nodes).map((n) => n.x - n.width / 2)));
  let minY = Math.floor(Math.min(...Object.values(workflowGraph.nodes).map((n) => n.y - n.height / 2)));

  Object.values(workflowGraph.nodes).forEach((node) => {
    node.x = Math.floor(node.x - minX + padding.x);
    node.y = Math.floor(node.y - minY + padding.y);
  });
}

export function calculateGraphSize(workflowGraph: WorkflowGraph, padding: { x: number; y: number } = { x: 0, y: 0 }) {
  let maxX = Math.floor(Math.max(...Object.values(workflowGraph.nodes).map((n) => n.x + n.width / 2)));
  let maxY = Math.floor(Math.max(...Object.values(workflowGraph.nodes).map((n) => n.y + n.height / 2)));

  workflowGraph.width = maxX + padding.x;
  workflowGraph.height = maxY + padding.y;
}
